<template lang="html">
  <div id="routeplan-details-box" class="white-box">
  	<div class="routeplan-details-topbar blue">

  		<div class="routeplan-details-step-btn noselect" @click="routeDetailsNavigate('back')" :class="{'disabled' : activeStep == 0}" tabindex="0">
  			<span class="material-icons" aria-hidden="true">chevron_left</span>
  		</div>

  		<div class="routeplan-details-step-btn noselect" @click="routeDetailsNavigate('forward')" :class="{'disabled' : activeStep == routeSteps.length-1}" tabindex="0">
  			<span class="material-icons" aria-hidden="true">chevron_right</span>
  		</div>

  		<div id="routeplan-details-headline">{{ routeName }}</div>

  		<div id="routeplan-details-close-btn" @click="closeRouteDetails" tabindex="0">
  			<span class="material-icons" aria-hidden="true">close</span>
  		</div>
  	</div>

  	<ul id="routeplan-details-list" v-if="stepsReady">
      <template v-for="(step,index) in routeSteps">
        <li :class="'routeplan-details-li details-li-'+step.number" :data-number="step.number" :data-lat="step.lat" :data-lng="step.lng" @click="goToStep($event);" tabindex="0">
          <div class="details-icon" v-html="step.arrow"></div>
          <div class="details-text">{{ step.description }}</div>
        </li>
      </template>
  	</ul>
  </div>
</template>

<script>
import { EventBus } from '@/main.js'
import MapFunctions from '@/assets/MapFunctions.js'

export default {
  data() {
    return {
      activeStep: 0,
      stepsReady: false,
      routeName: false,
      routeSteps: [],
    }
  },
  props: {
    routeData: {
      default: {},
    },
    placePage: {
      required: false,
      default: false,
    },
    placeName: {
      required: false,
    }
  },
  created() {
    this.createRouteSteps();
  },
  methods: {
    createRouteSteps() {
      var activeRoute;
      if(this.placePage) {
        activeRoute = this.routeData;
        this.routeName = this.placeName;
      }
      else {
        for(var i in this.routeData) {
          if(this.routeData[i].selected) {
            activeRoute = this.routeData[i].route;
            this.routeName = this.routeData[i].type == 'pedestrian' ? 'Fodgænger' : this.routeData[i].name;
          }
        }
      }
      console.log(activeRoute);
  		/*if(this.inTripMode) {
  			app.messageBox({
  				message: 'Vi viser nu detaljer for din rute frem til turforslaget.<br>'+
  						'<a href="/tag/'+app.findPrimaryTag(this.tripData).id+'/place/'+this.tripData.id+'/routeDescription" class="blue-text" onclick="app.closeMessageBox();">Klik her, hvis du i stedet vil se turforslaget trin-for-trin</a>',
  				btnText: "OK"
  			});
  		}*/
      var routeStep = 0;

      for(var i in activeRoute.simpleDescription) {
        if(activeRoute.simpleDescription[i] == 'SKIPTHIS') {
  				continue;
  			}

        i = parseInt(i);

        if(activeRoute.simpleDescription[i + 1] == undefined) {
          break;
        }

        var arrow = MapFunctions.determineArrow(activeRoute.simpleDescription[i]);
        var description = activeRoute.simpleDescription[i];

        if(i == activeRoute.firstCoords.length) {
          var pointLat = activeRoute.endCoords[1];
          var pointLng = activeRoute.endCoords[0];
        }
        else {
          var pointLat = activeRoute.firstCoords[i][0];
          var pointLng = activeRoute.firstCoords[i][1];
        }
        // workaround for bug in route description
        if(activeRoute.simpleDescription[i + 2] == undefined) {
          description = activeRoute.simpleDescription[i + 1];
          arrow = '<span class="material-icons routeplan-details-arrow">flag</span>';
        }
        this.routeSteps.push({lat: pointLat, lng: pointLng, arrow: arrow, description: description, number: routeStep});
        routeStep++;
      }

      this.stepsReady = true;

  		setTimeout(() => {
  			document.getElementsByClassName('details-li-0')[0].click();
  		}, 500);
  	},
    routeDetailsNavigate: function(direction) {
  		if(direction == 'back' && this.activeStep != 0) {
  			this.activeStep--;
        document.getElementsByClassName('details-li-'+this.activeStep)[0].click();
  		}
  		else if(direction == 'forward' && this.activeStep != this.routeSteps.length-1) {
  			this.activeStep++;
        document.getElementsByClassName('details-li-'+this.activeStep)[0].click();
  		}
  	},
    goToStep(e) {
      var elems = document.getElementsByClassName('routeplan-details-li');
      for(var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('details-selected');
      }
      e.currentTarget.classList.add('details-selected');
      this.activeStep = e.currentTarget.dataset.number;

      EventBus.$emit('goToStep', e.currentTarget.dataset.lat, e.currentTarget.dataset.lng);
    },
    closeRouteDetails() {
      if(this.placePage) {
        this.$router.go(-1);
      }
      else {
        EventBus.$emit('closeRouteDetails');
      }
    }
  },
}
</script>

<style lang="css">
  #routeplan-details-box {
  	position: absolute;
  	top: 60%;
  	left: 0px;
  	width: 100%;
  	height: 40%;
  	z-index: 2000;
  }

  @media screen and (min-width: 767px) {
  	#routeplan-details-box {
  		top: 10px;
  		left: 10px;
  		width: 500px;
  		height: 400px;
  	}
  }

  .routeplan-details-topbar {
  	position: relative;
  	top: 0px;
  	left: 0px;
  	height: 40px;
  	width: 100%;
  }

  .routeplan-details-step-btn {
  	position: relative;
  	top: 0;
  	left: 0px;
  	height: 40px;
  	width: 30px;
  	display: inline-block;
    cursor: pointer;
  }

  .routeplan-details-step-btn.disabled {
    opacity: 0.3;
  }

  .routeplan-details-step-btn .material-icons {
  	position: absolute;
  	top: 5px;
  }

  #routeplan-details-close-btn, #directions-description-close-btn {
  	position: absolute;
  	top: 0px;
  	right: 0px;
  	height: 40px;
  	width: 40px;
    cursor: pointer;
  }

  #routeplan-details-close-btn .material-icons, #directions-description-close-btn .material-icons {
  	position: absolute;
  	top: 5px;
  	left: 5px;
  }

  #routeplan-details-headline, #place-route-description-headline {
  	position: absolute;
  	top: 0px;
  	left: 60px;
  	height: 40px;
  	width: calc(100% - 100px);
  	line-height: 40px;
  	vertical-align: middle;
  	text-align: center;
  }

  #routeplan-details-list, #place-route-description-list {
  	height: calc(100% - 40px);
  	width: 100%;
  	overflow-y: auto;
  	margin: 0px;
  }

  #routeplan-details-list li, #place-route-description-list li {
  	min-height: 40px;
  	line-height: 40px;
  	vertical-align: middle;
  	border-bottom: 1px solid #ddd;
  	padding: 0px 5px;
  	font-size: 12px;
  	cursor: pointer;
  }

  #routeplan-details-list li.details-selected, #place-route-description-list li.details-selected {
  	background-color: rgba(000, 112, 141, 0.8);
  	color: #f8f8f8;
  }
  .details-icon {
    display: inline-block;
  }
  .details-text {
    display: inline-block;
    width: calc(100% - 20px);
  }
  .routeplan-details-arrow {
    position: relative;
    top: 2px;
    height: 15px;
    width: 15px;
    font-size: 15px !important;
  }
  .routeplan-details-arrow img, .routeplan-details-arrow svg {
    position: relative;
    left: 2px;
    display: inline-block !important;
    height: 15px;
    width: 15px;
  }

  .roundabout {
    position: relative;
    top: 15px;
    display: inline-block;
    height: 30px;
    width: 20px;
    background-image: url('~@/assets/img/roundabout.svg');
    background-size: 20px;
    background-repeat: no-repeat;
  }
</style>
